import { DiariaForm } from './DiariaForm';
import { SemanalForm } from './SemanalForm';
import { MensualForm } from './MensualForm';

// ── OPERARIO: APPCC ──────────────────────────────────────────────
export const APPCCSection = ({
  appccTab, setAppccTab, guardar,
  diaria, setDiaria, semanal, setSemanal, mensual, setMensual,
  firmaMensualRef, firmaMensualDibujada, setFirmaMensualDibujada, dibujandoMensual, setDibujandoMensual,
  limpiarFirmaMensual, getPosMensual,
}) => (
  <div className="space-y-4">
    <div className="flex gap-2 bg-white rounded-xl p-2 shadow">
      {[["Diaria", "📅 Diaria"], ["Semanal", "📆 Semanal"], ["Mensual", "📋 Mensual"]].map(([t, l]) => (
        <button key={t} onClick={() => setAppccTab(t)} className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${appccTab === t ? "bg-blue-600 text-white" : "text-gray-500 hover:bg-gray-100"}`}>{l}</button>
      ))}
    </div>
    {appccTab === "Diaria" && (
      <DiariaForm diaria={diaria} setDiaria={setDiaria} guardar={guardar} />
    )}
    {appccTab === "Semanal" && (
      <SemanalForm semanal={semanal} setSemanal={setSemanal} guardar={guardar} />
    )}
    {appccTab === "Mensual" && (
      <MensualForm
        mensual={mensual} setMensual={setMensual} guardar={guardar}
        firmaMensualRef={firmaMensualRef} firmaMensualDibujada={firmaMensualDibujada} setFirmaMensualDibujada={setFirmaMensualDibujada}
        dibujandoMensual={dibujandoMensual} setDibujandoMensual={setDibujandoMensual}
        limpiarFirmaMensual={limpiarFirmaMensual} getPosMensual={getPosMensual}
      />
    )}
  </div>
);
